import { useLocation } from 'react-router-dom';

export default function getQueryString(qsKey) {
  const searchParams = new URLSearchParams(useLocation().search);
  return searchParams.get(qsKey);
}
